export default "__VITE_ASSET__C2rTA6ms__"